export default {
  delivered: 'DELIVERED',
  error: 'ERROR',
  read: 'READ',
  sending: 'SENDING',
  sent: 'SENT'
}